import { useDispatch } from 'react-redux';
import { isPast } from 'date-fns';

import { formatBroadcastTime } from '@rikstv/play-common/src/utils/date/date.i18n.utils';
import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';
import { playbackActions } from '@rikstv/play-player/src/forces/player.slice';

import { Program } from '../../../forces/channels/channel.types';
import { Link } from '../../../router/Link';
import { BroadcastTimeOverlay } from '../../imageOverlays/BroadcastTimeOverlay';

import styles from './TvGuideProgramNavigation.module.css';

type NavigationProps = {
  program: Program;
  channelId: number;
  channelName: string;
  isCurrentProgram?: boolean;
  showBroadCastTimeOverlay?: boolean;
};

export const TvGuideProgramNavigation: FCC<NavigationProps> = ({ program, showBroadCastTimeOverlay, children }) => {
  const dispatch = useDispatch();
  if (program.url) {
    const handleClick = () => dispatch(playbackActions.requestAutoPlay());
    return (
      <Link
        className={styles.playLink}
        tabIndex={-1}
        to={program.url}
        onClick={handleClick}
        role="button"
        onKeyPress={handleClick}>
        {children}
      </Link>
    );
  }

  return (
    <div className={styles.upcoming}>
      {children}
      {!!showBroadCastTimeOverlay &&
        (isPast(new Date(program.time)) ? (
          <BroadcastTimeOverlay label="Ikke tilgjengelig" />
        ) : (
          <BroadcastTimeOverlay label={formatBroadcastTime(program.time, { useBroadcastDate: false })} />
        ))}
    </div>
  );
};
